<template>
<div class="chapter">
<div class="inner_page">
<p class="right2"><span class="textStyle0">ARTISTS IN<br/>
  CRIME</span></p>
<p class="right1"><span class="textStyle0">Ngaio Marsh</span></p>
<p class="right3"><span class="textStyle1">F</span><span class="textStyle111">ELONY</span> <span class="textStyle1">&amp;</span> <span class="textStyle1">M</span><span class="textStyle111">AYHEM</span> <span class="textStyle1">P</span><span class="textStyle111">RESS</span> • <span class="textStyle1">N</span><span class="textStyle111">EW</span> <span class="textStyle1">Y</span><span class="textStyle111">ORK</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?1bf2db99